import { useDatasources } from "./useDatasources";

/**
 * Reload the datasource list into the zustand store.
 * Call this after any create/delete that navigates to a page which does not
 * fetch on mount (Data Sources), so the new row is visible.
 */
export function refreshDatasources(): Promise<void> {
  return useDatasources.getState().fetchDatasources();
}

/**
 * Reload the list after a guest Share link succeeds.
 *
 * The list request sends the auth-store token. Call this only after that
 * store holds the new user token. The guest list has no projectId, and the
 * members page reads projectId from this list.
 */
export async function refreshDatasourcesAfterGuestLink(
  link: { ok: boolean } | null,
): Promise<void> {
  if (!link?.ok) return;
  await refreshDatasources();
}
